import { ReactNode, useState } from 'react';

type Props = {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultValue?: any;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  render: (arg0: (...args: Array<any>) => any, arg1: any) => ReactNode;
};
// eslint-disable-next-line react/function-component-definition, import/no-default-export
export default ({ defaultValue = null, render }: Props) => {
  const [currentSection, setCurrentSection] = useState(defaultValue);

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const toggle = (index: any) => {
    setCurrentSection(index === currentSection ? null : index);
  };

  return <>{render(toggle, currentSection)}</>;
};
